// Custom, on-brand glyphs for the onboarding wizard's mode callouts and the
// finish nudge. Hand-built (not stock lucide) so the booking-vs-AI-only fork
// reads as a deliberate product moment. All three inherit `currentColor`, so
// the surrounding container's text colour (amber for AI-only, purple for
// Bookings) still themes them.

type IconProps = {
  className?: string;
};

// AI-assistant-only: a chat bubble whose "thought" is a spark fed by two small
// data nodes. The AI answering + acting from connected sources.
export const AiAssistantIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H9l-4 3.5v-3.5H6.5" />
    <path d="M12 7.2l1.1 2.4 2.4 1.1-2.4 1.1L12 14.2l-1.1-2.4L8.5 10.7l2.4-1.1L12 7.2Z" fill="currentColor" stroke="none" />
    <circle cx="6.6" cy="10.4" r="0.95" fill="currentColor" stroke="none" />
    <circle cx="17.4" cy="10.4" r="0.95" fill="currentColor" stroke="none" />
  </svg>
);

// Dibs Bookings: a calendar card with a highlighted, checked slot. A booked
// appointment. More rounded/branded than lucide's CalendarCheck.
export const BookingsModeIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3.5" y="5" width="17" height="15" rx="3" />
    <path d="M3.5 9.5h17" />
    <path d="M8 3.2v3.4M16 3.2v3.4" />
    <rect x="7" y="12" width="4.2" height="4.2" rx="1" fill="currentColor" stroke="none" opacity="0.18" />
    <path d="M9.6 15.6l1.7 1.7 3.4-3.6" />
  </svg>
);

// Connect their data & actions (finish nudge): a hub node branching to three
// sources (URL feed / API / MCP), i.e. plugging external data into the agent.
export const ConnectDataIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="2.6" />
    <path d="M12 9.4V5.5M9.7 13.3l-2.8 2.8M14.3 13.3l2.8 2.8" />
    <circle cx="12" cy="4.4" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="5.8" cy="17.2" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="18.2" cy="17.2" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);
